module.exports = __webpack_public_path__ + "img/audioPlay.11422d17.png";